import { Build, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface IMaintenance {
  setOpen: (value: boolean) => void;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  drawerIsOpen: boolean;
}

export const Maintenance = (props: IMaintenance) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={props.drawerIsOpen ? '' : <Translate contentKey="global.menu.entities.maintenance">Maintenance</Translate>} placement="right">
        <ListItemButton
          id="maintenance-button"
          onClick={() => props.onExpand(props.index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: props.isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <Build />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.entities.maintenance">Maintenance</Translate>}
            primaryTypographyProps={{
              fontWeight: props.isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {props.isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={props.isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding onClick={() => props.setOpen(false)}>
          <MenuItem icon="asterisk" to="/part">
            <Translate contentKey="global.menu.entities.part" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/maintenance-model">
            <Translate contentKey="global.menu.entities.maintenanceModel" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/maintenance-review">
            <Translate contentKey="global.menu.entities.maintenanceReview" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/maintenance-vehicle-custom">
            <Translate contentKey="global.menu.entities.maintenanceVehicle" />
          </MenuItem>
        </List>
      </Collapse>
    </>
  );
};
